module.exports = __webpack_public_path__ + "assets/img/3982-gr.svg";